import './styles.scss';

const Separator = () => (
    <hr className="separator mb-4" />
);

export default Separator;
